import { useEffect, useRef, useState } from "react";
import { Trash2, Check } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import "./Bubbles.css";

function decodeRaw(b64) {
  try { return decodeURIComponent(escape(atob(b64))); } catch { return ""; }
}

function encodeRaw(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

function shortLabel(raw) {
  const trimmed = raw.replace(/^\{\{|\}\}$|^\{%|%\}$/g, "").trim();
  if (raw.startsWith("{{")) {
    const head = trimmed.split("|")[0].trim();
    return head || trimmed;
  }
  return trimmed.length > 24 ? trimmed.slice(0, 22) + "…" : trimmed;
}

export default function LiquidChipBubble({ anchorEl, iframeEl, onClose, onChange }) {
  const initial = decodeRaw(anchorEl.getAttribute("data-raw") || "") || anchorEl.textContent || "";
  const [raw, setRaw] = useState(initial);
  const taRef = useRef(null);

  useEffect(() => { taRef.current?.focus(); taRef.current?.select(); }, []);

  const isTag = initial.startsWith("{%");

  const apply = () => {
    const next = (raw || "").trim();
    if (!next) { remove(); return; }
    const isTagNow = next.startsWith("{%");
    anchorEl.setAttribute("data-raw", encodeRaw(next));
    anchorEl.setAttribute("data-kind", isTagNow ? "tag" : "output");
    anchorEl.className = isTagNow
      ? "liquid-chip liquid-chip-tag"
      : "liquid-chip liquid-chip-output merge-tag";
    anchorEl.textContent = isTagNow ? `{% ${shortLabel(next)} %}` : `{{${shortLabel(next)}}}`;
    if (!isTagNow) {
      const m = next.match(/^\{\{\s*(\w+)\s*\}\}$/);
      if (m) anchorEl.setAttribute("data-tag", m[1]);
      else anchorEl.removeAttribute("data-tag");
    } else {
      anchorEl.removeAttribute("data-tag");
    }
    onChange();
    onClose();
  };

  const remove = () => {
    const parent = anchorEl.parentNode;
    if (parent) parent.removeChild(anchorEl);
    onChange();
    onClose();
  };

  const onKey = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === "Enter") { e.preventDefault(); apply(); }
  };

  return (
    <FloatingBubble anchorEl={anchorEl} iframeEl={iframeEl} label={isTag ? "Liquid tag" : "Liquid variable"} onClose={onClose}>
      <div className="bubble-row" style={{ flexDirection: "column", gap: 8 }}>
        <textarea
          ref={taRef}
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          onKeyDown={onKey}
          rows={3}
          spellCheck={false}
          style={{
            width: 360,
            padding: "6px 8px",
            border: "1px solid #e2e8f0",
            borderRadius: 6,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: 12,
            resize: "vertical",
          }}
        />
        <div className="bubble-row" style={{ gap: 6, justifyContent: "flex-end" }}>
          <button type="button" className="bubble-btn danger" onClick={remove} title="Remove">
            <Trash2 size={13} /> Remove
          </button>
          <button type="button" className="bubble-btn primary" onClick={apply} title="Save (⌘/Ctrl+Enter)">
            <Check size={13} /> Save
          </button>
        </div>
      </div>
    </FloatingBubble>
  );
}
